import { render, staticRenderFns } from "./TriviaContentModal.vue?vue&type=template&id=5f85b134&"
import script from "./TriviaContentModal.vue?vue&type=script&lang=js&"
export * from "./TriviaContentModal.vue?vue&type=script&lang=js&"
import style0 from "./TriviaContentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports